import React from "react";
import { brand } from "../../config/brands";
import Logo from "./Logo";
import LogoMDP from "./LogoMDP";

const BrandLogo = (props) => {
  return brand.key === "mdp" ? <LogoMDP {...props} /> : <Logo {...props} />;
};

export default BrandLogo;
